module.exports = __webpack_public_path__ + "img/arrow-narrow-down-left.052e569f.svg";